module.exports = __webpack_public_path__ + "img/login-content-bg.e3b6cdb7.png";